import { VStack } from "@gluestack-ui/themed";
import { SecondCopyOfReceiptOptionsController } from "./controller";
import { SelectTransactionsList } from "@repo/core/components/core/SelectTransactionsList";
import { Button } from "@repo/core/components/core/Button";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const SelectSecondCopyOfReceipt = () => {
  const {
    back,
    selectedTransaction,
    transactionsOptions,
    isValid,
    isSubmitting,
    isFetching,
    handleOnChangeTransaction,
    onSubmit
  } = SecondCopyOfReceiptOptionsController();
  return (
    <Scaffolds.Root
      minHeight="$100vh"
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect
        title="2ª Via de Comprovante"
        showConfirmStoreModal
      >
        <Scaffolds.Form
          showHeader={false}
          centerFormContent={!isFetching && transactionsOptions.length === 0}
          footerContent={
            <VStack gap={16} justifyContent="flex-end" p="$4">
              <Button
                text="Ver comprovante"
                isDisabled={!isValid}
                isLoading={isSubmitting}
                textStyle={{
                  fontSize: "$md"
                }}
                onPress={onSubmit}
              />
              <Button
                text="Cancelar"
                action="negative"
                variant="outline"
                textStyle={{
                  fontSize: "$md"
                }}
                onPress={back}
              />
            </VStack>
          }
        >
          <VStack flex={1} px="$4">
            <SelectTransactionsList
              title="Transações do dia"
              isLoading={isFetching}
              date={new Date(Date.now())}
              transactions={transactionsOptions}
              selected={selectedTransaction}
              onChange={handleOnChangeTransaction}
            />
          </VStack>
        </Scaffolds.Form>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};
export default SelectSecondCopyOfReceipt;
